<script setup>
import {computed} from 'vue'
import {useAppStore} from '@/stores/appStore'
import BigBrandBedsReports from './BigBrandBedsReports.vue'
import OdpReports from './OdpReports.vue'
import PrintGiftsReports from './PrintGiftsReports.vue'

const appStore = useAppStore()

const sitename = computed(() => appStore.sitename)
const isBigBrandBeds = computed(() => sitename.value.indexOf('bigbrandbeds') === 0)
const isOdp = computed(() => sitename.value.indexOf('outdoorsproject') === 0)
const isPrintGifts = computed(() => sitename.value.indexOf('printgifts') === 0)
</script>

<template>
    <div>
        <BigBrandBedsReports v-if="isBigBrandBeds"/>
        <OdpReports v-if="isOdp"/>
        <PrintGiftsReports v-if="isPrintGifts"/>
    </div>
</template>